import { FormBase } from "../util/form-base-form";
import { Roles } from "../constants/roles";

export class ImportFileClearForm extends FormBase {
    private root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public getInput(): HTMLInputElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.IMPORT_FILE_INPUT}"]`, HTMLInputElement);
    }

    public getClearButton(): HTMLButtonElement | null {
        return this.queryElement(this.root, `[data-role="${Roles.IMPORT_FILE_CLEAR}"]`, HTMLButtonElement);
    }
}
